<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-form ref="formBusca">
            <v-row dense>
              <v-col cols="12" sm="12" md="12">
                <v-btn
                  v-if="$ability.can('Adicionar', 'Campanhas')"
                  outlined
                  color="blue darken-2"
                  rounded
                  dark
                  depressed
                  small
                  @click="$refs.dialogCreateCampanha.show()"
                >
                  <v-icon left>mdi-plus-circle</v-icon>Nova Campanha
                </v-btn>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-checkbox
                  v-model="filter.ativo"
                  label="Somente Ativos"
                  color="blue darken-2"
                />
              </v-col>
              <v-col cols="12">
                <v-row justify="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    @click="buscar()"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-data-table
            ref="dataTable"
            :headers="table.headers"
            :items="table.data"
            :search="table.search"
            :loading="loading"
            :loading-text="'Carregando...'"
            no-data-text="Nenhum registro"
            sort-by="nome"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="table.search"
                    label="Procurar..."
                    prepend-inner-icon="mdi-magnify"
                  />
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.dataCriacao`]="{ item }">{{
              $functions.formatDateFirebase(item.dataCriacao.seconds)
            }}</template>

            <template v-slot:[`item.dataExpiracao`]="{ item }">{{
              $functions.formatDateString(item.dataExpiracao)
            }}</template>

            <template v-slot:[`item.ativo`]="{ item }">
              <v-btn color="transparent" small fab depressed>
                <v-icon
                  :color="item.ativo ? 'green' : 'red'"
                  @click="updateAtivo(item)"
                  >{{ item.ativo ? "mdi-check" : "mdi-close" }}</v-icon
                >
              </v-btn>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip v-if="$ability.can('Editar', 'Campanhas')" bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="transparent"
                    v-on="on"
                    small
                    fab
                    depressed
                    @click="editCampanha(item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                Editar Campanha
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <DialogCreateCampanha ref="dialogCreateCampanha" @created="buscar()" />
    <DialogEditCampanha ref="dialogEditCampanha" @updated="buscar()" />
  </v-row>
</template>

<script>
import { Campanhas, Arquivos } from "@/services/materiais";

export default {
  name: "Campanhas",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogCreateCampanha: () => import("./components/DialogCreateCampanha"),
    DialogEditCampanha: () => import("./components/DialogEditCampanha"),
    DateMenu: () => import("../../../components/datepicker/DateMenu")
  },

  data() {
    return {
      loading: false,

      filter: {
        ativo: true
      },

      table: {
        search: "",

        headers: [
          {
            text: "Nome",
            value: "nome"
          },
          {
            text: "Dt. Cadastro",
            value: "dataCriacao"
          },
          {
            text: "Dt. Expiração",
            value: "dataExpiracao"
          },
          {
            text: "Ativo",
            value: "ativo"
          },
          {
            text: "Actions",
            value: "actions"
          }
        ],

        data: []
      }
    };
  },

  methods: {
    async buscar() {
      if (!this.$refs.formBusca.validate()) return;

      this.table.data = [];
      this.loading = true;
      this.$loading.setLoading(true);

      try {
        const campanhas = await new Campanhas().list(this.filter.ativo);
        this.table.data = campanhas;
      } catch (error) {
        this.$toast.error(error);
      } finally {
        this.loading = false;
        this.$loading.setLoading(false);
      }
    },

    editCampanha(item) {
      this.$refs.dialogEditCampanha.show(item);
    },

    async updateAtivo(campanha) {
      const index = this.$refs.dataTable.items.findIndex(
        item => item.id === campanha.id
      );
      let estadoInicial = campanha.ativo;
      let texto = "";
      if (campanha.ativo) {
        texto = `
          Deseja Desativar Campanha <strong>${campanha.nome}</strong>?<br/>
          Ao desativar a campanha também serão desativados todos os arquivos relacionador a essa campanha
        `;
      } else {
        texto = `
          Deseja Ativar Campanha <strong>${campanha.nome}</strong>?<br/>
          Ao ativar a campanha também serão ativados todos os arquivos relacionador a essa campanha
        `;
      }
      this.$swal.confirm(texto).then(async () => {
        try {
          campanha.ativo = !campanha.ativo;
          await new Campanhas().update(campanha.id, { ativo: campanha.ativo });
          await new Arquivos().updateArquivosCampanha(campanha);
          return Promise.resolve();
        } catch (error) {
          campanha.ativo = estadoInicial;
          await new Campanhas().update(campanha.id, { ativo: campanha.ativo });
          await new Arquivos().updateArquivosCampanha(campanha);
          this.$toast.error("Erro ao atualizar campanha");
          return Promise.reject(error);
        }
      });
    }
  }
};
</script>
